import {
    CREATE_SALESFORCE_CONNECTION_FAILURE,
    CREATE_SALESFORCE_CONNECTION_SUCCESS,
    DELETE_SALESFORCE_CONNECTION_FAILURE,
    DELETE_SALESFORCE_CONNECTION_SUCCESS,
    GET_SALESFORCE_CONNECTION_FAILURE,
    GET_SALESFORCE_CONNECTION_SUCCESS,
    GET_SALESFORCE_OBJECTS_FAILURE,
    GET_SALESFORCE_OBJECTS_SUCCESS,
    GET_SALESFORCE_OBJECT_DESCRIBE_FAILURE,
    GET_SALESFORCE_OBJECT_DESCRIBE_SUCCESS,
    GET_SALESFORCE_OBJECT_PREVIEW_FAILURE,
    GET_SALESFORCE_OBJECT_PREVIEW_SUCCESS,
    START_SALESFORCE_OAUTH_FAILURE,
    START_SALESFORCE_OAUTH_SUCCESS,
    UPDATE_SALESFORCE_CONNECTION_FAILURE,
    UPDATE_SALESFORCE_CONNECTION_SUCCESS
} from "./actions";

const initialState = {
    createConnectionResult: {
        success: true
    },
    createdConnection: null,
    startOAuthResult: {
        success: true
    },
    getConnectionResult: {
        success: true
    },
    connection: null,
    updateConnectionResult: {
        success: true
    },
    deleteConnectionResult: {
        success: true
    },
    getSalesforceObjectsResult: {
        success: true
    },
    salesforceObjects: null,
    getSalesforceObjectDescribeResult: {
        success: true
    },
    salesforceObjectDescribe: null,
    getSalesforceObjectPreviewResult: {
        success: true
    },
    salesforceObjectPreview: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE_SALESFORCE_CONNECTION_SUCCESS:
            return { ...state, createConnectionResult: { success: true }, createdConnection: action.payload.connection };
        case CREATE_SALESFORCE_CONNECTION_FAILURE:
            return { ...state, createConnectionResult: { success: false, ...action.payload.error }, createdConnection: null };
        case START_SALESFORCE_OAUTH_SUCCESS:
            return { ...state, startOAuthResult: { success: true, ...action.payload.result } };
        case START_SALESFORCE_OAUTH_FAILURE:
            return { ...state, startOAuthResult: { success: false, ...action.payload.error } };
        case GET_SALESFORCE_CONNECTION_SUCCESS:
            return { ...state, getConnectionResult: { success: true }, connection: action.payload.connection };
        case GET_SALESFORCE_CONNECTION_FAILURE:
            return { ...state, getConnectionResult: { success: false, ...action.payload.error }, connection: null };
        case UPDATE_SALESFORCE_CONNECTION_SUCCESS:
            return { ...state, updateConnectionResult: { success: true } };
        case UPDATE_SALESFORCE_CONNECTION_FAILURE:
            return { ...state, updateConnectionResult: { success: false, ...action.payload.error } };
        case DELETE_SALESFORCE_CONNECTION_SUCCESS:
            return { ...state, deleteConnectionResult: { success: true } };
        case DELETE_SALESFORCE_CONNECTION_FAILURE:
            return { ...state, deleteConnectionResult: { success: false, ...action.payload.error } };
        case GET_SALESFORCE_OBJECTS_SUCCESS:
            return { ...state, getSalesforceObjectsResult: { success: true }, salesforceObjects: action.payload.objects };
        case GET_SALESFORCE_OBJECTS_FAILURE:
            return { ...state, getSalesforceObjectsResult: { success: false, ...action.payload.error }, salesforceObjects: null };
        case GET_SALESFORCE_OBJECT_DESCRIBE_SUCCESS:
            return { ...state, getSalesforceObjectDescribeResult: { success: true }, salesforceObjectDescribe: action.payload.describe };
        case GET_SALESFORCE_OBJECT_DESCRIBE_FAILURE:
            return { ...state, getSalesforceObjectDescribeResult: { success: false, ...action.payload.error }, salesforceObjectDescribe: null };
        case GET_SALESFORCE_OBJECT_PREVIEW_SUCCESS:
            return { ...state, getSalesforceObjectPreviewResult: { success: true }, salesforceObjectPreview: action.payload.preview };
        case GET_SALESFORCE_OBJECT_PREVIEW_FAILURE:
            return { ...state, getSalesforceObjectPreviewResult: { success: false, ...action.payload.error }, salesforceObjectPreview: null };
        default:
            return state;
    }
};
